'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_signing_SigningApi$$anon$3(outer) {
  this.bWQ = null;
  this.bWO = null;
  this.bWP = false;
  this.bWM = null;
  this.bWN = false;
  this.bWR = false;
  this.bWS = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bWQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_signing_SigningApi$$anon$3 as $c_Lpresto_pages_signing_SigningApi$$anon$3 };
$p = $c_Lpresto_pages_signing_SigningApi$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_signing_SigningApi$$anon$3;
/** @constructor */
function $h_Lpresto_pages_signing_SigningApi$$anon$3() {
}
export { $h_Lpresto_pages_signing_SigningApi$$anon$3 as $h_Lpresto_pages_signing_SigningApi$$anon$3 };
$h_Lpresto_pages_signing_SigningApi$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bWQ;
});
$p.t = (function() {
  if ((!this.bWP)) {
    this.bWO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("reason", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bWP = true;
  }
  return this.bWO;
});
$p.ae = (function() {
  if ((!this.bWN)) {
    this.bWM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bWN = true;
  }
  return this.bWM;
});
$p.w = (function() {
  if ((!this.bWS)) {
    this.bWR = false;
    this.bWS = true;
  }
  return this.bWR;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_signing_SigningApi$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_signing_SigningApi$$anon$3, "presto.pages.signing.SigningApi$$anon$3", ({
  Xf: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_signing_SigningApi$$anon$3 as $d_Lpresto_pages_signing_SigningApi$$anon$3 };
//# sourceMappingURL=presto.pages.signing.-Signing-Api$$anon$3.js.map
